<template>
    <div>
        <!-- <input type="file" :name="name" :class="{'error': error, 'success': success}" :disabled="disabled" :value="value" @keyup.enter="$emit('enter')" @input="$emit('input',$event.target.value)" class="form-control" :placeholder="placeholder"> -->
        <label class="custom-file">
          <input :disabled="disabled" type="file" id="file" class="custom-file-input" @change="sendAmazon($event.target.files[0])">
          <span class="custom-file-control">{{placeholder}}</span>
        </label>
    </div>
</template>

<script>
import {AWS} from '../../../main.js'
// var fs = require('browserify-fs')
export default {
  props: {
    placeholder: String,
    // type: String,
    value: {
      type: [Number, String],
      required: false
    },
    disabled: {
      type: Boolean,
      required: false
    },
    error: {
      type: Boolean,
      required: false
    },
    success: {
      type: Boolean,
      required: false
    },
    name: {
      type: String,
      required: false
    }
  },
  data () {
    return {
    }
  },
  methods: {
    sendAmazon (logo) {
      var s3 = new AWS.S3()
      s3.upload({
        Bucket: 'keepneye',
        Key: logo.name,
        Body: logo,
        ContentType: logo.type
      },
      (err, data) => {
        if (err) {
          console.log('UPLOAD ERROR (' + logo.name + ') : ' + err)
        } else {
          this.$emit('input', data.Location)
        }
      })
    }
  }
}
</script>

<style scoped>
.error{
  border-color: red !important;
}
.success{
  border-color: #58d858 !important;
}
</style>
